export default __webpack_public_path__ + "static/media/hard_skill_tiles.49139f5e.svg";